import AuthManager from "commons/utils/Auth/AuthManager";
import { useEffect } from "react";
import GetAuthentication from "services/getAuthentication";

export default function AuthorizationHook() {
    useEffect(() => {
        const Authorization = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const redirect_uri = urlParams.get("redirect_uri");
            const client_id = urlParams.get("client_id");
            const refresh_token = urlParams.get("refresh_token");
            const expires_in = urlParams.get("expires_in");
            const access_token = urlParams.get("access_token");
            const apiUrl = `/account/v2/user/me`;

            localStorage.setItem(
                "auth",
                JSON.stringify({
                    accessToken: access_token,
                    dateCreated: new Date().getTime(),
                    dateExpireToken: AuthManager.calcDateExpireToken(
                        new Date().getTime(),
                        expires_in
                    ),
                    expiresIn: expires_in,
                    refreshToken: refresh_token,
                })
            );
            return await GetAuthentication(
                apiUrl,
                access_token,
                client_id,
                redirect_uri
            );
        };
        Authorization();
    }, []);
}
